import CircularProgress from '@mui/material/CircularProgress';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from './AuthContext';

export const ProtectedRoutes = () => {
    const { auth, token, patrolId } = useAuth();

    if (!auth.currentUser || !auth.currentUser.emailVerified) {
        return <Navigate to="/" />;
    }

    if (!token || !patrolId) {
        return <CircularProgress />;
    }

    return <Outlet />;
}
